// removed by extract-text-webpack-plugin
module.exports = {"settings":"_1Co43KzTWFxD2dhWoiztGz"};